import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-select',
  template: `
    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" *ngIf="to.label">{{ to.label }}</label>
    <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" [formControl]="formControl" [formlyAttributes]="field">
      <option *ngFor="let option of to.options | formlySelectOptions: field | async" [value]="option.value">
        {{ option.label }}
      </option>
    </select>
  `,
})
export class SelectFieldType extends FieldType<FieldTypeConfig> {

}
